import React from "react";
import { registerOperatorRoute } from "../../../routes";
import TagIcon from "mdi-material-ui/Tag";

import TagFormPage from "./pages/TagFormPageWithData";
import TagSettingsPage from "./pages/TagSettingsPageWithData";

export { default as DataTable } from "./components/TagDataTable";
export { default as TagDataTableColumn } from "./components/TagDataTableColumn";

registerOperatorRoute({
  isNavigationLink: false,
  isSetting: false,
  path: "/tags/create",
  mainComponent: TagFormPage
});

registerOperatorRoute({
  isNavigationLink: false,
  isSetting: false,
  path: "/tags/edit/:tagId",
  mainComponent: TagFormPage
});

registerOperatorRoute({
  isNavigationLink: true,
  isSetting: false,
  path: "/tags",
  priority: 30,
  mainComponent: TagSettingsPage,
  // eslint-disable-next-line react/display-name, react/no-multi-comp
  SidebarIconComponent: (props) => <TagIcon {...props} />,
  sidebarI18nLabel: "admin.tags.tags"
});
